let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aVR4N")).then(() => parcelRequire('8vJyT'));